import dateToString from '_/utils/dateToString'
import formatNumber from '_/utils/formatNumber'

const mat = (val, sp) => val ? val + (sp || '') : ''

const getProperty = r => {
  let f = mat((r.get('address') + ' ' + mat(r.get('strUnit'))).trim(), ', ') +
          mat(r.get('city'), ', ') + mat(r.get('state'))

  if (f.length === 2) f = ''
  return f.trim() || mat(r.get('county'), ' ') + mat(r.get('state')) || 'Unknown address'
}

const getSale = r => {
  if (r.get('saleT') === 'Sold') {
    return `Sold on ${dateToString(r.get('closeDt'))} for ${formatNumber(r.get('salePx'), '$')}`
  }
  else {
    return `For sale listed on ${dateToString(r.get('closeDt'))} for ${formatNumber(r.get('salePx'), '$')}`
  }
}

const getLease = r => {
  let s = ''
  if (r.has('suiteNo')) s += `Suite #${r.get('suiteNo')} `
  if (r.has('leaseT')) s += s ? `${r.get('leaseT').toLowerCase()} at ` : `${r.get('leaseT')} at `

  s += dateToString(r.get('leaseStDt'))

  if (r.get('askRentHPx') || r.get('askRentLPx')) {
    if (r.get('askRentHPx') && !r.get('askRentLPx')) {
      s += ` for ${formatNumber(r.get('askRentHPx'), '$')}`
    }
    else if (!r.get('askRentHPx') && r.get('askRentLPx')) {
      s += ` for ${formatNumber(r.get('askRentLPx'), '$')}`
    }
    else {
      s += ` for ${formatNumber(r.get('askRentLPx'), '$')}-${formatNumber(r.get('askRentHPx'), '$')}`
    }
  }

  if (r.get('leaseOptT')) {
    s += ` [${r.get('leaseOptT')}]`
  }

  if (r.get('lessee')) {
    s += ` [${r.get('lessee')}]`
  }

  return s
}

const getIncExp = r => {
  return r.get('oprExpRtPct') ? `OER ${r.get('oprExpRtPct')}% in ${r.get('incStYr')}` : `Income for ${r.get('incStYr')}`
}

const getConst = r => {
  return (r.get('constT') || 'Construction')+' in '+r.get('constYr')+(r.get('constPx') ? ' for ' + formatNumber(r.get('constPx'), '$') : '')
}

/**
 * Get display name for type given
 * @param  {String} type document type
 * @param  {Object} doc  immutable document instance
 * @return {String}      formatted record display name
 */
export default function getDisplayName (type, doc) {
  switch (type) {
    case 'property':
      return getProperty(doc)
    case 'sale':
      return getSale(doc)
    case 'lease':
      return getLease(doc)
    case 'incexp':
      return getIncExp(doc)
    case 'const':
      return getConst(doc)
  }

  return null
}



// WEBPACK FOOTER //
// ./modules/utils/getDisplayName.js